import { render, staticRenderFns } from "./page-header-v2.vue?vue&type=template&id=d9cf9862&scoped=true&"
import script from "./page-header-v2.vue?vue&type=script&lang=js&"
export * from "./page-header-v2.vue?vue&type=script&lang=js&"
import style0 from "./page-header-v2.vue?vue&type=style&index=0&id=d9cf9862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cf9862",
  null
  
)

export default component.exports